import React from 'react'
import { useHistory } from 'react-router-dom'

import { secureCache } from '~/utils/secureCache'
import {
  NO_INSURANCE,
  INELIGIBLE_INSURANCE_MESSAGE,
  SignupType,
  useSignupTypeSelectionOptions,
  usePayers,
} from './utils'
import { BenefitAdministrationType } from '~/utils/constants'
import { logEvent } from '~/utils/events'
import { SignupTypeSelectionUI, SignupTypeOption } from '~/components/screens/SignupTypeSelectionUI'

/**
 * Unauthenticated user type selection screen.
 */
const UserTypeSelection: React.FC = () => {
  const history = useHistory()
  const { data: options, isLoading: optionsLoading } = useSignupTypeSelectionOptions()
  const { data: payers, isLoading: payersLoading } = usePayers(BenefitAdministrationType.FIREFLY)
  const isLoading = optionsLoading || payersLoading

  const handleSelectOption = async (option: SignupTypeOption) => {
    const signupType = option.value as SignupType
    secureCache.set('signupType', signupType)
    // Handle side effects based on signup type
    if (signupType === SignupType.HEALTH_PLAN_MEMBER) {
      if (payers?.length !== 1) {
        history.push({ pathname: '/error' })
        return
      }
      secureCache.set('insurancePayerId', String(payers[0].id))
      logEvent('USER_SELECTED_ENROLLED_HEALTH_PLAN', {})
      history.push({ pathname: '/signup/name' })
    } else if (signupType === SignupType.HEALTH_PLAN_PROSPECT) {
      logEvent('USER_SELECTED_CONSIDERING_HEALTH_PLAN', {})
      history.push({ pathname: '/signup/invite-code' })
    } else if (signupType === SignupType.CARE_ONLY_MEMBER) {
      logEvent('USER_SELECTED_VIRTUAL_CARE_ONLY', {})
      history.push({ pathname: '/signup/insurance/payer' })
    }
  }

  const handleNoInsurance = () => {
    history.push({
      pathname: '/signup/insurance/ineligible',
      state: {
        title: INELIGIBLE_INSURANCE_MESSAGE[NO_INSURANCE]['title'],
        body: INELIGIBLE_INSURANCE_MESSAGE[NO_INSURANCE]['body'],
      },
    })
  }

  return (
    <SignupTypeSelectionUI
      options={options}
      onSelectOption={handleSelectOption}
      onNoInsurance={handleNoInsurance}
      isLoading={isLoading}
    />
  )
}

export default UserTypeSelection
